import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



    const cardData = {

keyword: "Online Cab Booking Pune",

headingDescription:
    "Rising Cab Service provides fast, secure, and convenient Online Cab Booking in Pune for local travel, airport transfers, railway station pickups, and outstation trips. Our easy booking system allows instant and advance cab reservations with a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars. With professional drivers, 24/7 availability, transparent pricing, and doorstep pickup, we ensure a smooth and reliable travel experience.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend getaway destinations from Pune, known for misty hills, waterfalls, green valleys, and scenic viewpoints like Tiger Point and Lion’s Point. These twin hill stations are ideal for short trips, monsoon drives, and family outings."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, dense forests, and cool climate. Popular attractions include Arthur’s Seat, Venna Lake, and Elephant’s Head Point, making it a perfect long weekend destination from Pune."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees visit Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi for spiritual blessings and peaceful darshan experiences."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a major religious and wine tourism destination near Pune, known for Trimbakeshwar Jyotirlinga, Sula Vineyards, and Godavari river ghats. It is ideal for both spiritual and leisure travel."
    },
    {
        title: "Goa",
        description:
            "Goa is a top holiday destination from Pune famous for beaches, nightlife, water sports, Portuguese forts, and scenic coastal beauty. It is ideal for long-distance leisure and group trips."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside views, colorful architecture, boating, and peaceful weekend relaxation surrounded by hills."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills and surrounded by dense forest. It is also a popular trekking destination for nature lovers and pilgrims."
    },
    {
        title: "Alandi",
        description:
            "Alandi is a holy pilgrimage town near Pune associated with Sant Dnyaneshwar Maharaj. It attracts thousands of devotees for spiritual visits and peaceful temple experiences."
    },
    {
        title: "Matheran",
        description:
            "Matheran is an eco-friendly hill station known for toy train rides, viewpoints, and pollution-free environment. It is a unique weekend getaway from Pune and Mumbai."
    },
    {
        title: "Tamhini Ghat",
        description:
            "Tamhini Ghat is a scenic mountain pass near Pune famous for waterfalls, misty valleys, and monsoon drives, making it a favorite road trip destination."
    }
],



services: [
{
name: "Online Cab Booking Pune",
description: "Rising Cab Service offers Online Cab Booking Pune for fast, secure, and convenient cab reservations across the city and outstation routes. Choose from AC Sedan, SUV, Innova Crysta, Kia Carens, and Tempo Traveller with professional drivers, doorstep pickup, and 24x7 availability for smooth travel experiences."
},
{
name: "Taxi Booking Pune",
description: "Book Taxi Booking Pune with Rising Cab Service for reliable local and long-distance travel. Enjoy well-maintained vehicles, experienced chauffeurs, transparent pricing, and quick booking confirmation for all travel needs."
},
{
name: "Cab Booking App in Pune",
description: "Our Cab Booking App in Pune service allows instant ride booking with real-time availability, easy interface, and quick driver allocation for hassle-free travel within and outside Pune."
},
{
name: "Online Taxi Booking Pune",
description: "Rising Cab Service provides Online Taxi Booking Pune for seamless travel planning with instant confirmation, multiple vehicle options, and safe, comfortable rides for all passengers."
},
{
name: "Mumbai Airport to Pune Taxi Online Booking",
description: "Book Mumbai Airport to Pune Taxi Online Booking for comfortable and timely airport pickup or drop with professional drivers, highway-safe vehicles, and 24x7 service availability."
},
{
name: "Online Cab Booking Mumbai to Pune",
description: "Our Online Cab Booking Mumbai to Pune service ensures smooth intercity travel with clean AC vehicles, experienced drivers, and flexible one-way or round-trip options."
},
{
name: "Online Cabs in Pune",
description: "Rising Cab Service offers Online Cabs in Pune for quick and easy booking with affordable pricing, multiple vehicle choices, and reliable service for all travel needs."
},
{
name: "Online Car Booking in Pune",
description: "Book Online Car Booking in Pune for convenient travel solutions including city rides, airport transfers, and outstation journeys with verified drivers and clean vehicles."
},
{
name: "Online Taxi Pune",
description: "Our Online Taxi Pune service ensures fast booking, safe rides, and comfortable travel experience with professional chauffeurs and 24x7 availability."
},
{
name: "Pune to Shirdi Cab Booking Online",
description: "Rising Cab Service offers Pune to Shirdi Cab Booking Online for easy pilgrimage travel with instant confirmation, AC vehicles, and safe highway driving."
},
{
name: "Taxi Booking in Pune",
description: "Book Taxi Booking in Pune for reliable transportation across city and outstation routes with transparent fares, clean cars, and professional drivers."
},
{
name: "Pune Cab Booking Online",
description: "Our Pune Cab Booking Online service provides instant booking, multiple vehicle options, and quick confirmation for all local and intercity travel needs."
},
{
name: "Book Taxi Online Pune",
description: "Rising Cab Service allows Book Taxi Online Pune for hassle-free reservations with safe drivers, clean vehicles, and 24x7 support."
},
{
name: "Online Taxi Service Pune",
description: "Book Online Taxi Service Pune for reliable, safe, and comfortable travel solutions across Pune city and nearby destinations."
},
{
name: "Pune Taxi Booking",
description: "Our Pune Taxi Booking service ensures quick ride confirmation, professional drivers, and affordable pricing for all travel requirements."
},
{
name: "Cab Service in Pune",
description: "Rising Cab Service provides Cab Service in Pune for local travel, airport transfers, and outstation trips with comfortable AC vehicles and experienced chauffeurs."
},
{
name: "Outstation Cab Booking Pune",
description: "Book Outstation Cab Booking Pune for safe intercity travel to Mumbai, Goa, Shirdi, Nashik, Mahabaleshwar, and more with reliable drivers and well-maintained cars."
},
{
name: "One Way Cab Booking Pune",
description: "Our One Way Cab Booking Pune service offers affordable drop-only travel with flexible pickup options and comfortable AC vehicles for long-distance routes."
},
{
name: "Pune Airport Cab Booking",
description: "Rising Cab Service provides Pune Airport Cab Booking for timely pickup and drop with professional drivers and 24x7 availability for stress-free airport travel."
},
{
name: "Innova Cab Booking Pune",
description: "Book Innova Cab Booking Pune for premium comfort, spacious seating, and smooth travel experience ideal for families and group trips."
},
{
name: "Affordable Cab Booking Pune",
description: "Our Affordable Cab Booking Pune service offers budget-friendly travel options without compromising safety, comfort, or reliability."
},
{
name: "24x7 Cab Service Pune",
description: "Rising Cab Service provides 24x7 Cab Service Pune ensuring round-the-clock availability for local and outstation travel needs anytime."
},
{
name: "Sedan Cab Booking Pune",
description: "Book Sedan Cab Booking Pune for economical and comfortable travel for small families and daily commuting with AC comfort and clean interiors."
},
{
name: "Instant Cab Booking Pune",
description: "Our Instant Cab Booking Pune service ensures immediate ride confirmation and fast pickup for urgent travel requirements."
},
{
name: "Best Online Cab Booking Pune",
description: "Rising Cab Service offers Best Online Cab Booking Pune with reliable drivers, clean vehicles, transparent pricing, and quick booking experience."
},
{
name: "Cheap Cab Booking Pune",
description: "Book Cheap Cab Booking Pune for affordable travel solutions across city and outstation routes without compromising safety and comfort."
},
{
name: "Online Outstation Taxi Pune",
description: "Our Online Outstation Taxi Pune service ensures safe and comfortable long-distance travel with professional drivers and flexible booking options."
}
],

tableData: [
["Online Cab Booking Pune","Taxi Booking Pune"],
["Cab Booking App in Pune","Online Taxi Booking Pune"],
["Mumbai Airport to Pune Taxi Online Booking","Online Cab Booking Mumbai to Pune"],
["Online Cabs in Pune","Online Car Booking in Pune"],
["Online Taxi Pune","Pune to Shirdi Cab Booking Online"],
["Taxi Booking in Pune","Pune Cab Booking Online"],
["Book Taxi Online Pune","Online Taxi Service Pune"],
["Pune Taxi Booking","Cab Service in Pune"],
["Outstation Cab Booking Pune","One Way Cab Booking Pune"],
["Pune Airport Cab Booking","Innova Cab Booking Pune"],
["Affordable Cab Booking Pune","24x7 Cab Service Pune"],
["Sedan Cab Booking Pune","Instant Cab Booking Pune"],
["Best Online Cab Booking Pune","Cheap Cab Booking Pune"],
["Online Outstation Taxi Pune","Online Cab Booking Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Easy Online Cab Booking in Pune",
        WhyChoosedescription: "Rising Cab Service provides quick and hassle-free online cab booking in Pune for local rides, airport transfers, outstation travel, corporate trips, and sightseeing tours."
    },
    {
        WhyChooseheading: "Instant Booking Confirmation",
        WhyChoosedescription: "Customers can conveniently reserve vehicles online and receive prompt booking assistance for planned and last-minute travel requirements."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Whether traveling within Pune or planning a trip to Mumbai, Nashik, Shirdi, Mahabaleshwar, Goa, or other destinations, we offer flexible cab booking solutions."
    },
    {
        WhyChooseheading: "Multiple Vehicle Categories Available",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel needs."
    },
    {
        WhyChooseheading: "Convenient Pickup Across Pune",
        WhyChoosedescription: "Online bookings are available for pickups from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and all major Pune areas."
    },
    {
        WhyChooseheading: "Suitable for Every Travel Purpose",
        WhyChoosedescription: "Our online cab booking service is ideal for airport transfers, office travel, family functions, pilgrimage tours, vacations, and business meetings."
    },
    {
        WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
        WhyChoosedescription: "Every vehicle is maintained for cleanliness, passenger comfort, and a pleasant travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Trusted by Daily and Frequent Travelers",
        WhyChoosedescription: "Rising Cab Service is preferred by families, professionals, students, tourists, and corporate customers looking for reliable transportation."
    }
]
};

const faqData = [
    {
        question: "What is Online Cab Booking in Pune?",
        answer: "Online Cab Booking allows customers to reserve a vehicle in advance for local travel, airport transfers, outstation trips, sightseeing tours, and corporate transportation."
    },
    {
        question: "Can I book a cab online for Pune Airport transfers?",
        answer: "Yes, online bookings are available for airport pickup and drop services across Pune and nearby areas."
    },
    {
        question: "Are outstation cab bookings available online?",
        answer: "Yes, customers can reserve cabs online for destinations across Maharashtra and other states."
    },
    {
        question: "Which vehicle options can be booked online?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles can be booked according to travel requirements."
    },
    {
        question: "Can I make an advance online booking?",
        answer: "Yes, advance reservations are available and recommended during holidays, weekends, and peak travel periods."
    },
    {
        question: "Is online booking available for corporate travel?",
        answer: "Yes, businesses and professionals can reserve vehicles online for meetings, employee transportation, and official travel."
    },
    {
        question: "Can I schedule a cab for railway station pickup?",
        answer: "Yes, online booking is available for Pune Railway Station pickups and drop-offs."
    },
    {
        question: "Do you provide Tempo Travellers through online booking?",
        answer: "Yes, Tempo Travellers and larger vehicles can be reserved online for group travel and tours."
    },
    {
        question: "Can online bookings be made for same-day travel?",
        answer: "Yes, depending on vehicle availability, customers can arrange same-day travel bookings."
    },
    {
        question: "How can I complete an Online Cab Booking in Pune?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Shinde",
        feedback:
            "The online booking process was simple and convenient. Within minutes, my cab was confirmed and the travel arrangements were handled smoothly.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Aarti Deshpande",
        feedback:
            "Using the online cab booking service saved a lot of time. The vehicle arrived as scheduled and the entire experience was professional and comfortable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Online Cab Booking Pune",
"image": "https://www.risingcabservice.com/assets/images/online-cab-booking-pune.jpg",
"description": "Book Online Cab Booking in Pune with Rising Cab Service for instant taxi booking, airport transfers, local rides, and outstation travel. Enjoy affordable fares and comfortable AC sedans, SUVs, and Innova cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/online-cab-booking-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Online Cab Booking Pune | Instant Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Online Cab Booking in Pune instantly with Rising Cab Service. Get reliable airport, local, and outstation taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="Online cab booking pune, Taxi booking pune, Cab booking app in pune, Online taxi booking pune, Mumbai airport to pune taxi online booking, Online cab booking mumbai to pune, Online cabs in pune, Online car booking in pune, Online taxi pune, Pune to shirdi cab booking online, Taxi booking in pune, Pune Cab Booking Online, Book Taxi Online Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinecabbookingpune;